import { PageProviders } from "./PageProviders";
import { PageResolver } from "./PageResolver";

export const StandardPageProviders = () => (
  <PageProviders>
    <PageResolver />
  </PageProviders>
);
